import { reactive } from 'vue';
import { v4 as uuidv4 } from 'uuid';

export const SYSTEM_SCRIPTS = ['boot', 'online', 'offline', 'idle_off', 'idle_short', 'idle_long'];

const DEFAULT_FLOWS = () =>
    Object.fromEntries(
        SYSTEM_SCRIPTS.map(name => [
            name,
            {
                nodes: [
                    {
                        id: `trigger-${name}`,
                        type: 'trigger',
                        position: { x: 40, y: 180 },
                        data: { scriptName: name },
                    },
                ],
                edges: [],
            },
        ])
    );

export const flowStore = reactive({
    flows: DEFAULT_FLOWS(),
    customScripts: [], // [{ name, nodes, edges }]
});

export function resetFlows() {
    flowStore.flows = DEFAULT_FLOWS();
    flowStore.customScripts = [];
}

export function getFlow(name) {
    return flowStore.flows[name] ?? null;
}

export function setFlow(name, { nodes, edges }) {
    if (SYSTEM_SCRIPTS.includes(name)) {
        flowStore.flows[name] = { nodes, edges };
    } else {
        const idx = flowStore.customScripts.findIndex(s => s.name === name);
        if (idx >= 0) {
            flowStore.customScripts[idx] = { name, nodes, edges };
        }
    }
}

export function addCustomScript(name) {
    const safeName = name.replace(/[^a-z0-9_-]/gi, '_');
    const entry = {
        name: safeName,
        nodes: [
            {
                id: `trigger-${safeName}-${uuidv4().slice(0, 8)}`,
                type: 'trigger',
                position: { x: 40, y: 180 },
                data: { scriptName: safeName },
            },
        ],
        edges: [],
    };
    flowStore.customScripts.push(entry);
    return entry;
}

export function removeCustomScript(name) {
    const idx = flowStore.customScripts.findIndex(s => s.name === name);
    if (idx >= 0) flowStore.customScripts.splice(idx, 1);
}

/** Serialize all flows for storage in the design file. */
export function exportFlows() {
    return {
        flows: JSON.parse(JSON.stringify(flowStore.flows)),
        customScripts: JSON.parse(JSON.stringify(flowStore.customScripts)),
    };
}

/** Restore flows from a previously exported snapshot. */
export function importFlows(data) {
    if (!data) return;
    if (data.flows) {
        for (const key of SYSTEM_SCRIPTS) {
            if (data.flows[key]) flowStore.flows[key] = data.flows[key];
        }
    }
    if (Array.isArray(data.customScripts)) {
        flowStore.customScripts = data.customScripts;
    }
}
